<div class="db-website-item-list-view">

  <div class="db-website-item-list-view__main-content db-website-item-list-view__thumb mr10"
       [ngStyle]="{backgroundImage: 'url(&quot;'+ (website?.screenshot && !website?.isLocalhost ?
       'data:image/jpg;base64,' + website?.screenshot : '../../../assets/images/common/no_screenshot.svg') + '&quot;)'}">

    <div class="db-website-item-list-view__actions">
      <a class="db-website-item-list-view__action-button mr5"
         [href]="website?.site_url" target="_blank" rel="noopener"
         [dsTooltip]="'text_wpFrontInfoDesc' | dbText" dsTooltipAlign="left" dsTooltipSize="small">
        <i class="db-icon db-icon-ds-eye"></i></a>
      <a *ngIf="website?.isActive" class="db-website-item-list-view__action-button"
         dbWpLink [adminLink]="website?.adminUrl" [websiteId]="website?.id" target="_blank" rel="noopener"
         [dsTooltip]="WPAdminTooltipRef" dsTooltipAlign="left" dsTooltipSize="small">
        <i class="db-icon db-icon-ds-wordpress"></i></a>
    </div>
  </div>

  <div class="db-website-item-list-view-info-wrap">

    <div>
      <div class="db-website-item-list-view__title" [dsTooltip]="website?.title" dsTooltipColor="black"
           dsTooltipSize="small" dsTooltipAlign="left" [dsTooltipVisible]="website?.title?.length > 24"
           [innerHTML]="website?.title"></div>
    </div>
    <a class="db-website-item-list-view__site-url"
       [href]="website?.site_url" target="_blank" rel="noopener" [dsTooltip]="websiteUrl" dsTooltipColor="black"
       dsTooltipSize="small" dsTooltipAlign="left" [dsTooltipVisible]="websiteUrl.length > 26"
       [innerHTML]="websiteUrl"></a>
  </div>

  <div class="db-website-item-list-view-data-wrap">
    <div>
      <p class="title">Registered</p>
      <p>{{website?.registeredAt | dbDate: 'dd MMM y'}}</p>
    </div>
    <div *ngIf="website?.lastUpdated && website.lastUpdated != 'Invalid Date'">
      <p class="title">Last updated</p>
      <p>{{website?.lastUpdated | dbDate: 'dd MMM y'}}</p>
    </div>
  </div>

  <div class="db-website-item-list-view-manage-action-wrap">
    <a class="ds-btn-blue ds-btn-small mr10" (click)="manageWebsite()">
      <span [innerHTML]="'text_manageButton' | dbText"></span>
    </a>
    <a class="db-website-item-actions__list" [ngClass]="{'hide': isRootSubSite}"
       [dsTooltip]="actionsRef" dsTooltipMode="click"
       dsTooltipAlign="right" dsTooltipSize="small">
      <i class="db-icon db-icon-ds-more-l"></i></a>
  </div>
</div>

  <ng-template #WPAdminTooltipRef>
    <p class="ds-tooltip-title"
       [innerHTML]="'text_wpAdminInfoTitle' | dbText"></p>
    <p [innerHTML]="'text_wpAdminInfoDesc' | dbText"></p>
  </ng-template>

<ng-template #actionsRef>
  <div class="db-website-item-actions__list-dropdown">
    <p (click)="removeWebsite()" [innerHTML]="'text_removeDemoWebsite' | dbText"></p>
  </div>
</ng-template>
